import { useTranslation } from 'react-i18next';

const stats = [
  { value: '12', suffix: '+', labelKey: 'stats.years', icon: 'ri-calendar-check-line' },
  { value: '500', suffix: '万', labelKey: 'stats.users', icon: 'ri-user-heart-line' },
  { value: '150', suffix: '+', labelKey: 'stats.countries', icon: 'ri-global-line' },
  { value: '99.9', suffix: '%', labelKey: 'stats.uptime', icon: 'ri-shield-star-line' },
];

export default function StatsSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-12 md:py-16 bg-primary-600">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-full bg-background-50/15 text-background-50">
                <i className={`${stat.icon} text-lg`} />
              </div>
              <div className="flex items-baseline justify-center gap-0.5">
                <span className="text-3xl md:text-4xl font-heading font-bold text-background-50">
                  {stat.value}
                </span>
                <span className="text-lg md:text-xl font-semibold text-accent-300">
                  {stat.suffix}
                </span>
              </div>
              <p className="mt-1.5 text-xs md:text-sm text-background-50/70 font-medium">
                {t(stat.labelKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}